/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type ProductDistributionPaginatedProperty =
  typeof ProductDistributionPaginatedProperty[keyof typeof ProductDistributionPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductDistributionPaginatedProperty = {
  PRODUCT_NAME: 'PRODUCT_NAME',
  PLATFORM_NAME: 'PLATFORM_NAME',
  BANK_NAME: 'BANK_NAME',
  CUSTOMER_LAST_NAME: 'CUSTOMER_LAST_NAME',
  CUSTOMER_FIRST_NAME: 'CUSTOMER_FIRST_NAME',
  AMOUNT: 'AMOUNT',
  DISTRIBUTION_TYPE: 'DISTRIBUTION_TYPE',
  DISTRIBUTION_STATUS: 'DISTRIBUTION_STATUS',
  CREATED_AT: 'CREATED_AT',
} as const;
